import { FunctionComponent } from 'react';
import { DialogModal } from '../../../app-kit/components/DialogModal/DialogModal';
import { SuburbPageVGDisclaimerModalContentWithData } from './SuburbPageVGDisclaimerModalContent/SuburbPageVGDisclaimerModalContentWithData';

interface VGDisclaimerModal {
  opened: boolean;
  onClose: () => void;
}

export const SuburbPageVGDisclaimerModal: FunctionComponent<VGDisclaimerModal> = ({
  opened,
  onClose,
}) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
      title="Disclaimer"
    >
      <SuburbPageVGDisclaimerModalContentWithData />
    </DialogModal>
  );
};
